<template>
  <section>
    <div class="view-desktop">
      <div class="avatar-container">
        <div class="img-container">
          <img
            v-if="!dadosPaciente.Avatar"
            :src="require(`../../assets/images/avatars/31.svg`)"
            alt="Avatares"
          />
          <img
            v-else
            :src="
              require(`../../assets/images/avatars/${dadosPaciente.Avatar}.svg`)
            "
            alt="Avatares"
          />
        </div>
        <span @click="showModal = true"
          ><i class="icon-ic_edit" />{{ $t('botoes.alterar-imagem') }}</span
        >
      </div>
    </div>
    <modal-template
      v-if="showModal"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h2>{{ $t('perfil.imagem-perfil') }}</h2>
      </template>
      <template #body>
        <vue-select-image
          :data-images="avatars"
          @onselectimage="onSelectImage"
        />
        <button class="button button-secondary" @click="changeAvatar">
          {{ $t('botoes.atualizar') }}
        </button>
      </template>
    </modal-template>
  </section>
</template>

<script>
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import router from '@/router'

export default {
  components: {
    ModalTemplate
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    ...mapGetters({
      avatars: 'getAvatars',
      dadosPaciente: 'dadosPaciente'
    })
  },

  methods: {
    ...mapMutations(['SET_AVATAR']),
    ...mapActions(['atualizarAvatar']),
    toggleInfoModal() {
      this.showModal = !this.showModal
    },
    onSelectImage: function (data) {
      this.imageSelected = data
    },
    changeAvatar() {
      this.atualizarAvatar(this.imageSelected.id)
        .then(() => {
          this.SET_AVATAR(this.imageSelected.id)
          this.toggleInfoModal()
        })
        .catch((err) => {
          if (err instanceof NotAuthenticatedError) router.push('/')
        })
    }
  },

  created() {
    this.$store.dispatch('initAvatars')
  }
}
</script>

<style lang="scss" scoped src="@/assets/stylesheets/components/personal-data/SelectImage.scss"></style>
